<template>
  <div class="d-flex flex-column h-100" v-if="organization">
    <slot :handleButtonClick="activateModal"/>

    <b-modal v-model="organizationModal" title="Update Billing"  hide-footer>
      <div v-bind:class="{alert: activeError, 'alert-danger': activeError}" role="alert" v-html="errorText"></div>

      <organization-billing-form :organization="organization"
                                 :saving="saving"
                                 @cancel="handleUpdateCancel"
                                 @save="updateOrganization"/>
    </b-modal>
  </div>
</template>

<script>
import OrganizationBillingForm from "./OrganizationBillingForm";
import GeneralMixins from "../../../mixins/GeneralMixins";
import {OrganizationsApi} from "../../Api/OrganizationsApi.js";

export default {
  components: {OrganizationBillingForm},
  mixins: [GeneralMixins],

  props: ['reloadOnSave'],

  data: function () {
    return {
      organization: null,
      organizationModal: false,
      saving: false,
      activeError: false,
      errorText: '',
    }
  },

  async mounted() {
    this.organization = await OrganizationsApi.getOrganization()
  },

  methods: {
    activateModal: function () {
      this.organizationModal = true;
    },

    setError: function (error) {
      this.activeError = true;
      this.errorText = error;
    },

    removeError: function () {
      this.activeError = false;
      this.errorText = '';
    },

    updateOrganization: async function (params) {
      this.saving = true;
      try {
        this.organization = await OrganizationsApi.updateOrganization(params)
      } catch (e) {
        this.setError(this.getErrorMessagesHtml(e))
      } finally {
        this.saving = false;
        this.organizationModal = false;
        if (this.reloadOnSave) {
          window.location.reload()
        }
      }
    },

    handleUpdateCancel: function () {
      this.removeError();
      this.organizationModal = false;
    }
  }
}
</script>